var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCommitSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    rx: 2,
    fill: "#0CB0B0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 5.66675H8.11071C8.027 5.20088 7.769 4.77777 7.38256 4.47261C6.99612 4.16745 6.50625 4 6 4C5.49375 4 5.00388 4.16745 4.61744 4.47261C4.231 4.77777 3.973 5.20088 3.88929 5.66675H1V6.33325H3.88929C3.973 6.79912 4.231 7.22223 4.61744 7.52739C5.00388 7.83255 5.49375 8 6 8C6.50625 8 6.99612 7.83255 7.38256 7.52739C7.769 7.22223 8.027 6.79912 8.11071 6.33325H11V5.66675ZM6 7.33299C5.71746 7.33299 5.44126 7.25481 5.20633 7.10834C4.9714 6.96187 4.7883 6.75368 4.68017 6.51011C4.57205 6.26654 4.54376 5.99852 4.59888 5.73995C4.654 5.48137 4.79006 5.24386 4.98985 5.05744C5.18964 4.87102 5.44418 4.74406 5.7213 4.69263C5.99842 4.64119 6.28565 4.66759 6.54669 4.76848C6.80773 4.86937 7.03084 5.04022 7.18781 5.25943C7.34479 5.47864 7.42857 5.73636 7.42857 6C7.42815 6.35341 7.2775 6.69223 7.00968 6.94213C6.74187 7.19202 6.37875 7.33259 6 7.33299Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommitSearch);
export default __webpack_public_path__ + "static/media/commit_search.c55ff12fcd36c2c1274deecf2f3b3c98.svg";
export { ForwardRef as ReactComponent };